// extracted by mini-css-extract-plugin
module.exports = {"content":"Settings_content__nEb0D","divider":"Settings_divider__J8cyw","header":"Settings_header__2ifdJ","title":"Settings_title__2cDCJ"};